module.exports = __webpack_public_path__ + "static/media/39-1.0bb8d400.mp3";